import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MemeCard from './Post';
import { Col, Container, Row } from 'react-bootstrap';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));

export default function CustomGrid(props) {

  return (
    <div>
        <Container style={{padding: 10}}>
            <Row>
                {props.memes.length ? props.memes.map(meme=>{
                  return (
                    <Col md="12" lg="4" key={meme.id}>
                      <MemeCard getMemes={props.getMemes} data={meme} deletePost={props.deletePost} />
                    </Col>
                  )
                }) : <section id="cover" className="min-vh-100">
                      <div id="cover-caption">
                        <div className="container">
                            <div className="row">
                            <div className="col-xl-5 col-lg-6 col-md-8 col-sm-10 mx-auto text-center form p-2">
                            <h1 className="display-8 py-2 text">Nothing to see here...</h1>
                        </div>
                      </div>
                      </div>
                  </div>
                </section>
              }
            </Row>
        </Container>
    </div>
  );
}
